import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

interface AuditCheckListProps {
  isOpen?: boolean;
  onClose?: () => void;
  onSubmit?: (selectedChecklist: string) => void;
}

const AuditCheckList: React.FC<AuditCheckListProps> = ({ 
  isOpen = true, 
  onClose,
  onSubmit 
}) => {
  const [selectedChecklist, setSelectedChecklist] = useState<string>("");
  const [isDropdownOpen, setIsDropdownOpen] = useState<boolean>(false);

  // Available checklist options
  const checklistOptions = [
    "ICU Audit",
    "Fire Prevention — General",
    "General Ward",
    "Electrical Room"
  ];

  const handleSubmit = () => {
    if (selectedChecklist && onSubmit) {
      onSubmit(selectedChecklist);
    }
    if (onClose) {
      onClose();
    }
  };

  const handleCancel = () => {
    setSelectedChecklist("");
    if (onClose) {
      onClose();
    }
  };

  const handleDropdownSelect = (option: string) => {
    setSelectedChecklist(option);
    setIsDropdownOpen(false);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg w-full max-w-md mx-4">
        {/* Header */}
        <div className="px-6 py-4 border-b border-gray-200">
          <h2 className="text-xl font-semibold text-gray-800">
            Select Check List
          </h2>
        </div>

        {/* Content Section */}
        <div className="px-6 py-6">
          <div className="relative">
            <button
              type="button"
              className="w-full px-4 py-3 text-left border border-gray-300 rounded-lg bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent flex items-center justify-between"
              onClick={() => setIsDropdownOpen(!isDropdownOpen)}
            >
              <span className={selectedChecklist ? "text-gray-900" : "text-gray-500"}>
                {selectedChecklist || "Select Check List"}
              </span>
              <ChevronDown 
                className={`h-5 w-5 text-gray-400 transition-transform ${
                  isDropdownOpen ? "rotate-180" : ""
                }`} 
              />
            </button>

            {/* Dropdown Options */}
            {isDropdownOpen && (
              <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg">
                <div className="py-1">
                  {checklistOptions.map((option, index) => (
                    <button
                      key={index}
                      type="button"
                      className="w-full px-4 py-3 text-left hover:bg-gray-50 focus:outline-none focus:bg-gray-50 text-gray-900 border-b border-gray-100 last:border-b-0"
                      onClick={() => handleDropdownSelect(option)}
                    >
                      {option}
                    </button>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Footer */}
        <div className="px-6 py-2 bg-gray-500 border-t border-gray-200 flex justify-end gap-3">
          <button
            type="button"
            onClick={handleCancel}
            className="flex items-center justify-center font-semibold gap-3 bg-gray-400 text-white px-4 py-2 rounded-full"
          >
            CANCEL
          </button>
          <button
            type="button"
            onClick={handleSubmit}
            disabled={!selectedChecklist}
            className="flex items-center justify-center font-semibold gap-3 bg-[#0fa9a6] text-white px-4 py-2 rounded-full"
          >
            CREATE
          </button>
        </div>
      </div>

      {/* Click outside to close */}
      {isDropdownOpen && (
        <div
          className="fixed inset-0 z-5"
          onClick={() => setIsDropdownOpen(false)}
        />
      )}
    </div>
  );
};

export default AuditCheckList;
